export default __webpack_public_path__ + "static/saaslogo-120f124704c1ea9048981466ecf88c7d.svg";